import React, {Component} from "react";
import PropTypes from "prop-types";
import "./snackbar.css";

import {ReactComponent as PositiveCheckmarkIcon} from "../../../images/icons/ui/snackbar/PositiveCheckmark.svg";
import {ReactComponent as NegativeCrossIcon} from "../../../images/icons/ui/snackbar/NegativeCross.svg";
import {ReactComponent as NeutralCrossIcon} from "../../../images/icons/ui/snackbar/NeutralCross.svg";
import {ReactComponent as NegativeAlertIcon} from "../../../images/icons/ui/snackbar/NegativeAlert.svg";
import {ReactComponent as AttentionAlertIcon} from "../../../images/icons/ui/snackbar/AttentionAlert.svg";
import {ReactComponent as NeutralInformationIcon} from "../../../images/icons/ui/snackbar/NeutralInformation.svg";
import {ReactComponent as NeutralOperationIcon} from "../../../images/icons/ui/snackbar/NeutralOperation.svg";
import {ReactComponent as NegativeBlockIcon} from "../../../images/icons/ui/snackbar/NegativeBlock.svg";
import {ReactComponent as CloseIcon} from "../../../images/icons/ui/snackbar/closeIcon.svg";
import Button from "../button/button";


const ICONS = {
    PositiveCheckmark: <PositiveCheckmarkIcon/>,
    NegativeCross: <NegativeCrossIcon/>,
    NeutralCross: <NeutralCrossIcon/>,
    NegativeAlert: <NegativeAlertIcon/>,
    AttentionAlert: <AttentionAlertIcon/>,
    NeutralInformation: <NeutralInformationIcon/>,
    NeutralOperation: <NeutralOperationIcon/>,
    NegativeBlock: <NegativeBlockIcon/>,
};

class Snackbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            snackbars: [],
        };
    }

    addSnackbar = (message, options = {}) => {
        const {icon, additionalText, buttonLabel, onButtonClick, divider, closeable} = options;
        const newSnackbarId = `${Date.now()}-${Math.random()}`
        this.setState((prevState) => {
            const newSnackbars = [
                ...prevState.snackbars,
                {
                    id: newSnackbarId,
                    message,
                    icon,
                    additionalText,
                    buttonLabel,
                    onButtonClick,
                    divider,
                    closeable,
                },
            ];
            return {snackbars: newSnackbars.slice(-3)};
        }, () => setTimeout(() => this.removeSnackbar(newSnackbarId), 5000));
    };

    removeSnackbar = (id) => {
        this.setState((prevState) => {
            return {snackbars: prevState.snackbars.filter((snackbar) => snackbar.id !== id)};
        });
    };

    render() {
        return (
            <div className="snackbar-container">
                {this.state.snackbars.map((snackbar) => (
                    <div
                        key={snackbar.id}
                        className={`snackbar ${snackbar.additionalText ? 'snackbar-large' : ''}`}
                    >
                        {snackbar.icon && <span className="icon">{ICONS[snackbar.icon]}</span>}
                        <div className='content'>
                            <span className="message">{snackbar.message}</span>
                            {snackbar.additionalText &&
                                <div className="additional-text">{snackbar.additionalText}</div>}
                        </div>
                        {snackbar.buttonLabel && (
                            <Button
                                customClass="button" size='small' type='text'
                                onClick={snackbar.onButtonClick || (() => {
                                })}
                            >
                                {snackbar.buttonLabel}
                            </Button>
                        )}
                        {snackbar.divider && snackbar.closeable && <div className="divider"/>}
                        {snackbar.closeable && (
                            <Button
                                customClass={`close-button ${snackbar.divider ? 'with-divider' : ''}`} size='small'
                                type='text'
                                onClick={() => this.removeSnackbar(snackbar.id)}
                                startIcon={<CloseIcon/>}
                            />
                        )}
                    </div>
                ))}
            </div>
        );
    }
}

Snackbar.propTypes = {
    snackbars: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            message: PropTypes.string.isRequired,
            icon: PropTypes.oneOf(Object.keys(ICONS)),
            additionalText: PropTypes.string,
            buttonLabel: PropTypes.string,
            onButtonClick: PropTypes.func,
            divider: PropTypes.bool,
            closeable: PropTypes.bool,
        })
    ),
};

export default Snackbar;

export class SnackbarProvider extends Component {
    constructor(props) {
        super(props);
        this.snackbarRef = React.createRef();
    }

    addSnackbar = (message, type = "info", options = {}) => {
        if (this.snackbarRef.current) {
            this.snackbarRef.current.addSnackbar(message, type, options);
        }
    };

    render() {
        return (
            <>
                <Snackbar ref={this.snackbarRef}/>
                {React.cloneElement(this.props.children, {
                    addSnackbar: this.addSnackbar,
                })}
            </>
        );
    }
}

SnackbarProvider.propTypes = {
    children: PropTypes.node.isRequired,
};